module.exports = {
  CAMPAIGNS: 'campaigns',
  CUSTOM_BITLY: 'customBitly',
  SENT_POSTS_30_DAYS: 'sentPosts30Days',
  CALENDAR: 'calendar',
  CUSTOMIZE_UTM_PARAM: 'customizeUTMParam',
  APPROVAL_FLOW: 'approvalFlow',
  DRAFTS: 'drafts',
  SHOP_GRID: 'shopGrid',
  STORIES: 'stories',
  TWITTER_IMPRESSIONS: 'twitterImpressions',
  ANALYTICS_ON_POSTS: 'analyticsOnPosts',
  FIRST_COMMENT: 'firstComment',
  SHARE_NEXT: 'shareNext',
  TAG_USERS_IN_IMAGES: 'tagUsersInImages',
  PINTEREST: 'pinterest',
  CUSTOM_VIDEO_THUMBNAIL_INSTAGRAM: 'customVideoThumbnailInstagram',
  HASHTAG_MANAGER: 'hashtagManager',
  CHANNEL_GROUPS_IN_COMPOSER: 'channelGroupsInComposer',
  TEAMS_PANEL: 'teamsPanel',
  CONTENT: 'content',
};
